// extracted by mini-css-extract-plugin
export default {"container":"CategoryPage_container__Tta0N","main":"CategoryPage_main__btzEQ","title":"CategoryPage_title__4+bsM"};